import mixins from 'synergycms_core/src/less/mixins';

export default {
  header: {},
  app: {
    backgroundColor: "#fff",
    height: '100%',
    position: 'relative',
    /* minHeight:'calc(100vh + 49px)', */
    display:'flex',
    //flexDirection:'column',
    flexWrap:'wrap',
    justifyContent:'stretch',
    '& ul': {
      margin: 0,
      padding: 0,
      '& > li': {
        listStyle: 'none'
      }
    },
    '& input:focus': { outline: 'none' },
    '& select:focus': { outline: 'none' },
    '& textarea:focus': { outline: 'none' },
    '& button:focus': { outline: 'none' },
    '& $header': {
      textAlign: 'center',
      width: '100%',
      display: 'block',
      color: 'white',
      fontSize: '14px',
      zIndex: '60',
      margin: '0',
      boxSizing: 'border-box',
      position: 'relative',
      padding: '10px',
      height: '100%',
      backgroundColor: data => data.backgroundColor,
      '& h1': {
        margin: '5px 0 0 0'
      },
      '&:lang(ar)':{
        direction:'rtl'
      }
    },
    /* '@media (min-width:901px)': {
      minHeight:'calc(100vh + 40px)',
    } */
  },
  timeoutModalTable: {
    display: 'table',
    height: '100%',
    width: '100%',
  },
  timeoutModalTableCell: {
    display: 'table-cell',
    verticalAlign: 'middle',
    textAlign: 'center',
    padding: '20px',
    position:'relative'
  },
  timeoutModalWhite: {
    padding: '50px 30px',
    margin: '0 auto',
    background: '#ffffff',
    textAlign: 'center',
    position:'relative',
    fontFamily: data => data.fontFamily1,
    '@media (min-width:601px)': {
      padding: '45px',
      maxWidth: '470px',
      boxSizing:'border-box'
    }
  },
  amenityIconTitle:{
    fill: data => data.mainColor,
    width: '45px',
    height: '45px',
    marginBottom: '30px',
    '@media (min-width:601px)': {
      width: '65px',
      height: '65px',
    }
  },
  timeoutModalTitle: {
    display: "block",
    textTransform: "uppercase",
    color: "#000",
    fontSize: '18px',
    fontWeight: '400',
    lineHeight:'21px',
    marginBottom: '25px',
    '@media (min-width:601px)': {
      fontSize: '20px',
      lineHeight:'23px'
    }
  },
  timeoutModalContent: {
    overflow: 'auto',
    font: "16px 'Roboto'",
    color: '#8c8c8c',
    background: 'rgba(0, 0, 0, 0.25)',
    position: 'fixed',
    left: '0',
    top: '0',
    right: '0',
    bottom: '0',
    zIndex: '600',
    display: 'flex',
    justifyContent: 'center',
  },
  timeoutModalLogo: {
    display: 'block',
    textTransform: 'uppercase',
    fontWeight: '500',
    marginBottom: '36px',
    color: '#000'
  },
  centerText:{},
  timeoutModalInfo: {
    display: 'block',
    fontSize: '13px',
    fontWeight:400,
    color: '#8c8c8c',
    lineHeight: '15px',
    marginBottom: '11px',
    textAlign:'left',
    paddingTop:'10px',
    '&$centerText':{
      textAlign: 'center',
    },
    '@media (min-width:601px)': {
      fontSize:'14px',
      lineHeight:'16px'
    }
  },
  sendMailContainer: {
    margin:'20px 0 0',
    '@media (min-width:601px)': {
      marginTop:'16px'
    }
  },
  buttonTextStyle: {
    fontFamily: 'inherit',
    fontStyle: 'unset',
    fontWeight: 'bolder',
    pointerEvents: 'none'
  },
  customImageCode: {
    fontSize: '25px'
  },
  timeoutAcceptButton: {
    border: data => '1px solid ' + data.secondColor,
    backgroundColor: data => data.secondColor,
    color: '#fff',
    ...mixins.boxSizing('content-box'),
    textTransform: 'uppercase',
    cursor: 'pointer',
    textAlign: 'center',
    padding: '16px',
    fontSize:'15px',
    lineHeight:'17px',
    fontWeight:'500',
    margin:'25px 0 35px',
    '&:hover': {
      backgroundColor: 'transparent',
      ...mixins.transitionAll(),
      color: data => data.secondColor
    },
    '@media (min-width:601px)': {
      margin:'20px 0 30px'
    }
  },
  textSendSelection: {
    padding: '6px'
  },
  sendContainer: {
    display: 'table-cell',
    verticalAlign: 'middle',
    '& > div': {
      padding: '0 15px 0 0',
      '& > button': {
        width: '175px',
        padding: '13px 0'
      }
    }
  },
  sendRequest: {
    color: data => data.mainColor,
    display: 'block',
    marginTop: '20px',
    fontSize: '13px'
  },
  amenityIcon:{
    width:'18px',
    height:'18px',
    position:'absolute',
    left:0,
    top:'50%',
    fill: data => data.mainColor,
    marginTop:'-9px'
  },
  timeoutList:{
    listStyle:'none',
    margin:0,
    padding:'0 0 0 12px'
  },
  timeoutListInfo:{
    composes:'$timeoutModalInfo',
    position:'relative',
    margin:'0',
    padding:'9px 0 10px 30px',
  },
  closeButton:{
    width:'22px',
    top:'20px',
    right:'30px',
    position: 'absolute',
    zIndex: '600',
    background: 'none',
    cursor: 'pointer',
    color: data => data.mainColor,
    border: '0',
    fontSize: '22px',
    '&:lang(ar)':{
      left:'15px',
      right:'auto',
      float:'left'
    }
  },
  socialLogo:{
    width:'26px',
    height:'26px',
    display:'block',
    '& > svg':{
      width:'26px',
      height:'26px',
      fill: data => data.mainColor,
    },
  },
  socialIconList:{
    display:'flex',
    flexWrap:'nowrap',
    justifyContent:'space-between',
    alignContent:'center',
    listStyle:'none',
    margin:0,
    padding:'35px 0 0',
    '@media(min-width:801px)':{
      paddingTop:'37px',
      maxWidth:'235px',
      margin:'0 auto'
    }
  },
  socialIconElement:{
    padding:'0 12px',
    '&:last-of-type':{
      paddingRight:'0'
    }
  }
};
